import classNames from 'classnames'
import { assetFolders, vendorImages } from 'common/constants'
import { NavLink } from 'components/Share/Link'
import { LayoutContext } from 'contexts/LayoutContext'
import { useContext, useEffect } from 'react'
import Image from 'react-bootstrap/Image'
import { useGlobalStore } from 'store/useGlobalStore'
import BurgerButton from './BurgerButton'
import { StyledBranding, StyledHeader } from './Layout.styled'
import { NavBar } from './NavBar'
import { UserMenu } from './UserMenu'
import { updateCurrentAssetFolder } from 'utils/assetFolderUtils'

interface IProps {
  enableSticky?: boolean
  className?: string
}

const GetLogoURL = (assetFolder, isSticky) => {
  let url = isSticky
    ? assetFolder !== assetFolders.Independent
      ? vendorImages.whiteLogo
      : vendorImages.rightLogo
    : vendorImages.rightLogo
  if (assetFolder === undefined) {
    return url.replace('/{assetFolder}', '')
  }
  return url.replace('{assetFolder}', assetFolder)
}

export const Header = ({ enableSticky = false, className }: IProps) => {
  const { isSticky: sticky } = useContext(LayoutContext)
  const [isAuthenticated, assetFolder] = useGlobalStore((state) => [
    state.isAuthenticated,
    state.userClaims.CurrentBuyerTypeAssetFolder
  ])

  let isSticky = sticky && enableSticky

  if (!assetFolder) {
    isSticky = false
  }

  useEffect(() => {
    updateCurrentAssetFolder(assetFolder)
  }, [assetFolder])

  return (
    <StyledHeader
      style={{
        position: enableSticky ? 'sticky' : null,
        display: enableSticky && !sticky ? 'none' : null
      }}
      isSticky={isSticky}
      assetFolder={assetFolder}
      className={classNames('d-print-none', className)}
    >
      <StyledBranding isSticky={isSticky} assetFolder={assetFolder}>
        <NavLink to="/">
          <Image className="img-fluid" src={GetLogoURL(assetFolder, isSticky)} alt="" />
        </NavLink>
      </StyledBranding>
      {isAuthenticated && <BurgerButton isSticky={isSticky} />}
      <NavBar isSticky={isSticky} assetFolder={assetFolder} />
      <UserMenu showInMobile={false} isSticky={isSticky} assetFolder={assetFolder} />
    </StyledHeader>
  )
}

export const HeaderParent = () => {
  return (
    <>
      <Header className="main-nav" />
      <Header enableSticky />
    </>
  )
}
